import { memo } from 'react';
import { logStatusMeta, campaignStatusMeta } from './status';
import type { CampaignStatus, CommLogStatus, DealStatus } from './types';

interface StatusBadgeProps {
  status: CommLogStatus | CampaignStatus | DealStatus;
  variant?: 'log' | 'campaign';
}

export const StatusBadge = memo(function StatusBadge({ status, variant = 'log' }: StatusBadgeProps) {
  const meta = variant === 'campaign'
    ? campaignStatusMeta(status as CampaignStatus)
    : logStatusMeta(status as CommLogStatus);

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${meta.bg} ${meta.text} ${meta.darkBg} ${meta.darkText}`}
    >
      {meta.pulse ? (
        <span className="relative flex h-1.5 w-1.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-75" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-current" />
        </span>
      ) : null}
      {meta.label}
    </span>
  );
});
